













import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "login",
  components: {
    school: () => import("./module/school.vue"),
    teacher: () => import("./module/teacher.vue")
  }
})
export default class Login extends Vue {
  get isTeacher () {
    return this.$route.name;
  }
}
